"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTypography = void 0;
var colors_1 = require("../colors");
exports.MuiTypography = {
    styleOverrides: {
        root: { wordBreak: 'break-word' },
        paragraph: {
            fontSize: 14,
            lineHeight: '150%',
            color: colors_1.tannerGray['900'],
        },
        body1: { fontSize: 14, lineHeight: '150%', color: colors_1.tannerGray['900'] },
        body2: { fontSize: 12, lineHeight: '150%', color: colors_1.tannerGray['900'] },
        h1: { fontSize: 28, fontWeight: 800, lineHeight: '150%' },
        h2: { fontSize: 20, fontWeight: 800, lineHeight: '150%' },
        h3: { fontSize: 16, fontWeight: 800, lineHeight: '150%' },
        h4: {
            fontSize: 14,
            fontWeight: 800,
            lineHeight: '150%',
        },
        h5: { fontSize: 16, fontWeight: 'bold', lineHeight: '150%' },
        h6: { fontSize: 16, fontWeight: 'normal', lineHeight: '150%' },
    },
};
//# sourceMappingURL=MuiTypography.js.map